"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _find = _interopRequireDefault(require("lodash/find"));
var _Option = _interopRequireDefault(require("../components/Option"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BaseTemplate = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BaseTemplate, _React$Component);
  var _super = _createSuper(BaseTemplate);
  function BaseTemplate() {
    (0, _classCallCheck2["default"])(this, BaseTemplate);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(BaseTemplate, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propsEqual = (0, _isEqual["default"])(this.props, nextProps);
      var stateEqual = (0, _isEqual["default"])(this.state, nextState);
      return !propsEqual || !stateEqual;
    }
  }, {
    key: "render",
    value: function render() {
      var dependentOptions = [];
      var _this$props = this.props,
        options = _this$props.options,
        choices = _this$props.choices,
        children = _this$props.children;
      choices.filter(function (choice) {
        return choice.isSelected && choice.dependentOptions && choice.dependentOptions.length > 0;
      }).forEach(function (choice) {
        choice.dependentOptions.forEach(function (dependentOption) {
          dependentOptions.push((0, _find["default"])(options, function (option) {
            return option.id === dependentOption;
          }));
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "option-component"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "parent-option"
      }, children), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dependent-options"
      }, dependentOptions.length > 0 && dependentOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement(_Option["default"], {
          key: option.id,
          option: option
        });
      })));
    }
  }]);
  return BaseTemplate;
}(_react["default"].Component);
BaseTemplate.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  choices: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$configurator = state.configurator,
    options = _state$configurator.options,
    choices = _state$configurator.choices,
    choiceGroups = _state$configurator.choiceGroups;
  var option = options[ownProps.option];
  var optionChoices = option.choices.map(function (cid) {
    return choices[cid];
  });
  var optionChoiceGroups = option.choiceGroups.map(function (cgid) {
    return {
      id: choiceGroups[cgid].groupId,
      name: choiceGroups[cgid].name,
      sequenceNumber: choiceGroups[cgid].sequenceNumber
    };
  });
  return {
    options: options.allIds.map(function (oid) {
      return options[oid];
    }),
    choices: optionChoices,
    activeChoices: optionChoices.filter(function (x) {
      return x.isActive;
    }),
    choiceGroups: optionChoiceGroups
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(BaseTemplate);
//# sourceMappingURL=BaseTemplate.js.map